import { Module } from 'vuex'
import { State } from '@plugin/store'

function getNowFormatDate() {
  const day = new Date()
  let Year = 0
  let Month = 0
  let Day = 0
  let CurrentDate = ''
  Year = day.getFullYear()
  Month = day.getMonth() + 1
  Day = day.getDate()
  CurrentDate += Year + '-'
  if (Month >= 10) {
    CurrentDate += Month + '-'
  } else {
    CurrentDate += '0' + Month + '-'
  }
  if (Day >= 10) {
    CurrentDate += Day
  } else {
    CurrentDate += '0' + Day
  }
  return CurrentDate
}
const nowdate = getNowFormatDate()

export interface Asn {
  remark: string;
  asnHeadFileList: [];
  invoice: [];
  deliveryAddressId: string;
  expectedArrivalDate: string;
  shippingAddressId: string;
  options1: [];
  options2: [];
  consigneeInfo: object;
  shipper: object;
}

const store: Module<Asn, State> = {
  namespaced: true,
  state: {
    remark: '',
    asnHeadFileList: [],
    invoice: [],
    deliveryAddressId: '',
    shippingAddressId: '',
    expectedArrivalDate: nowdate,
    options1: [],
    options2: [],
    consigneeInfo: { receiver: '', receiverPhone: '', receiveStartTime: '', receiveDueTime: '', shippingWarehouse: '' },
    shipper: { sender: '', delWarehouse: '', senderPhone: '' }
  },
  mutations: {
    assignment(state, data) {
      state.remark = data.remarks
      state.asnHeadFileList = data.asnHeadFileList
      state.invoice = data.invoice
    },
    dateChanged(state, time) {
      state.expectedArrivalDate = time
    },
    deliveryAddress(state, data) {
      state.deliveryAddressId = data.id
      state.options1 = data.options1
      state.consigneeInfo = data.consigneeInfo
    },
    shippingAddress(state, data) {
      state.shippingAddressId = data.id
      state.options2 = data.options2
      state.shipper = data.shipper
    },
    reset(state) {
      state.remark = ''
      state.asnHeadFileList = []
      state.invoice = []
      state.deliveryAddressId = ''
      state.shippingAddressId = ''
      state.expectedArrivalDate = nowdate
      state.options1 = []
      state.options2 = []
      state.consigneeInfo = { receiver: '', receiverPhone: '', receiveStartTime: '', receiveDueTime: '', shippingWarehouse: '' }
      state.shipper = { sender: '', delWarehouse: '', senderPhone: '' }
    }
  },
  actions: {
    add({ commit }, data) {
      commit('assignment', data)
    },
    alter({ commit }, time) {
      commit('dateChanged', time)
    },
    delivery({ commit }, data) {
      commit('deliveryAddress', data)
    },
    shipping({ commit }, data) {
      commit('shippingAddress', data)
    },
    condition({ commit }) {
      commit('reset')
    }
  }
}
export default store
